import { backendHttpClient } from '@/core/services/api.service';

/**
 * Excel ile indirme işlmeleri için kullanılbilir Fn
 * @param {string} url - API endpoint URL
 * @param {Object} params - İstek parametreleri
 * @param {string} fileName - İndirilecek dosyanın adı
 * @param {Object} additionalHeaders - Ekstra HTTP başlıkları
 * @returns {Promise} - İşlem sonucunu döndüren promise
 */
export const downloadExcelFile = (url, params, fileName, additionalHeaders = {}) => {
  return new Promise((resolve, reject) => {
    const headers = {
      ...additionalHeaders
    };

    backendHttpClient.get(url, {
      responseType: "blob",
      params: {
        ...params,
        _cache: new Date().getTime() // Cache önleme
      },
      headers
    })
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // Dosya indirme işlemi
      const fileURL = window.URL.createObjectURL(blob);
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
      
      // Bellek temizliği
      setTimeout(() => {
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      }, 100);
      
      resolve(true);
    })
    .catch((error) => {
      console.error("Excel dosyası indirme hatası:", error);
      
      const errorResponse = {
        status: error.response?.status || 0,
        message: error.response?.data?.message || error.message || 'Bilinmeyen hata',
        error: error
      };
      
      reject(errorResponse);
    });
  });
};
